module.exports = __webpack_public_path__ + "media/images/map-icons/truck_selected-70afea73df843665c08259fa70ae0ed4.svg";